import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  title: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      marginRight: '10px'
    }
  },
  avatar: {
    backgroundColor: palette.info.main,
    border: '1px solid',
    borderRadius: '50%',
    color: palette.common.white,
    height: '36px',
    width: '36px',
    fontSize: '18px',
    lineHeight: '34px',
    fontFamily: palette.fontFamilies.poppins,
    fontWeight: '600',
    textAlign: 'center',
    marginRight: '10px',
    flexShrink: '0'
  },
  teamMember: {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(palette.shades[400]),
    display: 'flex',
    fontFamily: palette.fontFamilies.poppins,
    padding: '8px 42px',
    justifyContent: 'space-between',
    '&.multiple': {
      padding: '8px 40px 8px 42px'
    },
    '&.selected': {
      backgroundColor: '#EBF0F5'
    }
  },
  teamMemberInfo: {
    display: 'flex',
    alignItems: 'center'
  },
  activeItem: {
    backgroundColor: palette.success.light
  },
  teamMemberActions: {
    '& .actionText': {
      display: 'flex',
      alignItems: 'center',
      '& .MuiButtonBase-root': {
        padding: '0',
        minWidth: '36px',
        marginLeft: '8px'
      }
    }
  },
  form: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch'
  },
  formContent: {
    overflowY: 'auto',
    flexGrow: '1',
    minHeight: '580px',
    '&.disableMinHeight': {
      minHeight: 'unset'
    }
  },
  formContentHeader: {
    padding: '0 40px',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '16px'
  },
  formContentInviteSearchSection: {
    padding: '0 40px'
  },
  formContentMembersList: {
    height: '450px',
    overflow: 'scroll',
    '&.selectWrapper': {
      height: '402px'
    }
  },
  formContentMembersListDisableScroll: {
    height: 'unset',
    overflow: 'unset'
  },
  modalFooter: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[400])
  },
  footerEven: {
    display: 'flex',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    }
  },
  footerButton: {
    display: 'inline-block',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      width: '100%',
      '& + &': {
        marginTop: '10px',
        marginLeft: '0'
      },
      '& button': {
        width: '100%'
      }
    }
  },
  footerWrapper: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  },
  rightButton: {
    '& + &': {
      marginLeft: '10px'
    }
  },
  resetPadding: {
    padding: '0 0'
  },
  noTeamMembers: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginTop: '12px'
  },
  email: {
    fontSize: '11px',
    lineHeight: '14px'
  },
  checkbox: {
    marginRight: '4px'
  },
  selectAll: {
    padding: '12px 42px 0 42px',
    marginBottom: '-14px',
    '& .MuiTypography-root': {
      color: '#00767C',
      fontSize: '13px',
      fontWeight: '600',
      marginLeft: '4px',
      fontFamily: palette.fontFamilies.poppins
    }
  }
}));
export default useStyles;